import { useCallback, useEffect, useRef, useState } from 'react'
import { useDebounce } from 'src/mtska-frontend-app-scaffolding/hooks/useDebounce'
import { getFormattedRows, moveArrayElement } from './list.functions'
import { GridCellModes } from '@mui/x-data-grid'
import { SettingsContext } from 'src/mtska-frontend-app-scaffolding'

// Logica di abilitazione della modalità edit al single click su una cell
export const useCellModes = () => {

    const [cellModesModel, setCellModesModel] = useState({})

    const handleCellClick = useCallback((params = {}, event = {}) => {
        const { currentTarget, target } = event
        const { nodeType } = target
        const { isEditable } = params

        if (!isEditable || (nodeType === 1 && !currentTarget.contains(target))) return

        setCellModesModel((prevModel) => {
            return {
                // Revert the mode of the other cells from other rows
                ...Object.keys(prevModel).reduce(
                    (acc, id) => ({
                        ...acc,
                        [id]: Object.keys(prevModel[id]).reduce(
                            (acc2, field) => ({
                                ...acc2,
                                [field]: { mode: GridCellModes.View },
                            }),
                            {}
                        ),
                    }),
                    {}
                ),
                [params.id]: {
                    // Revert the mode of other cells in the same row
                    ...Object.keys(prevModel[params.id] || {}).reduce(
                        (acc, field) => ({ ...acc, [field]: { mode: GridCellModes.View } }),
                        {}
                    ),
                    [params.field]: { mode: GridCellModes.Edit }
                }
            }
        })
    }, [])

    const handleCellModesModelChange = useCallback((newModel) => {
        setCellModesModel(newModel)
    }, [])

    return { cellModesModel, handleCellClick, handleCellModesModelChange }
}

// Logica di preparazione, gestione, salvataggio delle rows
export const useRows = ({ config, dataProviderName: model, doAction = () => { }, items }) => {

    const [rows, setRows] = useState()

    const previousItemsRef = useRef(null)

    useEffect(() => {
        const { tableConfig } = config?.data?.modules[model] || {}
        const { current } = previousItemsRef
        const isSameItems = current && JSON.stringify(current) === JSON.stringify(items)
        if (items && (items.length > 0 || (items.length === 0 && rows)) && tableConfig && !isSameItems) {
            setRows(getFormattedRows({ items, tableConfig }))
            previousItemsRef.current = items
        }
    }, [config, items])

    const processRowUpdate = (newRow, oldRow, configAction) => {
        const { id } = newRow
        const key = Object.keys(newRow).find((key) => newRow[key] !== oldRow[key])
        const action = configAction || `${key}Management`
        if (key) {
            setRows((prev) => prev.map((row) => row?.id === id ? newRow : row))
            const data = { id, [key]: newRow[key] }
            doAction({ action, data, model })
            return newRow
        } else return oldRow
    }

    return { processRowUpdate, rows }
}

// Logica per gestire la copia delle righe
export const useCopiedRows = ({ rows, rowSelectionModel }) => {

    const [copied, setCopied] = useState(false)

    const onCopy = () => {
        const selectedRows = rows.filter(row => rowSelectionModel.includes(row.id))
        const header = Object.keys(selectedRows[0]).join('\t')
        const data = selectedRows.map((row) => Object.values(row).join('\t'))
        const textToCopy = [header, ...data].join('\n')
        navigator.clipboard.writeText(textToCopy).then(() => {
            setCopied(true)
            setTimeout(() => setCopied(false), 2000)
        })
    }

    return { copied, onCopy }
}

